import { render, staticRenderFns } from "./TopbarSP.vue?vue&type=template&id=56ae16c6&scoped=true"
import script from "./TopbarSP.vue?vue&type=script&lang=js"
export * from "./TopbarSP.vue?vue&type=script&lang=js"
import style0 from "./TopbarSP.vue?vue&type=style&index=0&id=56ae16c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae16c6",
  null
  
)

export default component.exports